import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import Typography from "@mui/material/Typography";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import IconButton from "@mui/material/IconButton";
import ChevronRightOutlined from "@mui/icons-material/ChevronRightOutlined";
import ImageRounded from "@mui/icons-material/ImageRounded";
import { Filetype } from "../../../../../../shell/store/media-revamp";
import { useParams } from "../../../../../../shell/hooks/useParams";
type ImageFilterRow = {
  onClose: () => void;
};
export const ImageFilterRow: FC<ImageFilterRow> = ({
  onClose
}) => {
  const {
    t
  } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [params, setParams] = useParams();
  const handleClose = () => {
    setAnchorEl(null);
    onClose();
  };
  const handleChange = (filetype: Filetype) => {
    setParams(filetype, "filetype");
    handleClose();
    onClose();
  };
  return <>
      <MenuItem onClick={event => setAnchorEl(event.currentTarget)} data-sentry-element="MenuItem" data-sentry-source-file="ImageFilterRow.tsx">
        <ListItemIcon data-sentry-element="ListItemIcon" data-sentry-source-file="ImageFilterRow.tsx">
          <ImageRounded fontSize="small" data-sentry-element="ImageRounded" data-sentry-source-file="ImageFilterRow.tsx" />
        </ListItemIcon>
        <ListItemText data-sentry-element="ListItemText" data-sentry-source-file="ImageFilterRow.tsx">{t("media.filetypeFilterImages")}</ListItemText>
        <ListItemIcon style={{
        minWidth: "0px"
      }} data-sentry-element="ListItemIcon" data-sentry-source-file="ImageFilterRow.tsx">
          <ChevronRightOutlined fontSize="small" data-sentry-element="ChevronRightOutlined" data-sentry-source-file="ImageFilterRow.tsx" />
        </ListItemIcon>
      </MenuItem>
      <Menu open={open} onClose={handleClose} anchorEl={anchorEl} anchorOrigin={{
      /*
        The list has a verticle padding of 8px
        We need the submenu to be flush with the top of the main dropdown
        menu, NOT flush with the first item in the menu. So we must cancel
        out the padding of the list with vertical: -8px
      */
      vertical: -8,
      horizontal: "right"
    }} data-sentry-element="Menu" data-sentry-source-file="ImageFilterRow.tsx">
        <MenuItem onClick={() => handleChange("Image")} data-sentry-element="MenuItem" data-sentry-source-file="ImageFilterRow.tsx">
          <Typography variant="body1" data-sentry-element="Typography" data-sentry-source-file="ImageFilterRow.tsx">
            {t("media.imageFilterAllTypes")}
          </Typography>
        </MenuItem>
        <MenuItem onClick={() => handleChange("PNG")} data-sentry-element="MenuItem" data-sentry-source-file="ImageFilterRow.tsx">
          <Typography variant="body1" data-sentry-element="Typography" data-sentry-source-file="ImageFilterRow.tsx">PNG</Typography>
        </MenuItem>
        <MenuItem onClick={() => handleChange("JPEG")} data-sentry-element="MenuItem" data-sentry-source-file="ImageFilterRow.tsx">
          <Typography variant="body1" data-sentry-element="Typography" data-sentry-source-file="ImageFilterRow.tsx">JPEG</Typography>
        </MenuItem>
        <MenuItem onClick={() => handleChange("SVG")} data-sentry-element="MenuItem" data-sentry-source-file="ImageFilterRow.tsx">
          <Typography variant="body1" data-sentry-element="Typography" data-sentry-source-file="ImageFilterRow.tsx">SVG</Typography>
        </MenuItem>
        <MenuItem onClick={() => handleChange("WEBP")} data-sentry-element="MenuItem" data-sentry-source-file="ImageFilterRow.tsx">
          <Typography variant="body1" data-sentry-element="Typography" data-sentry-source-file="ImageFilterRow.tsx">WEBP</Typography>
        </MenuItem>
        <MenuItem onClick={() => handleChange("GIF")} data-sentry-element="MenuItem" data-sentry-source-file="ImageFilterRow.tsx">
          <Typography variant="body1" data-sentry-element="Typography" data-sentry-source-file="ImageFilterRow.tsx">GIF</Typography>
        </MenuItem>
        <MenuItem onClick={() => handleChange("AVIF")} data-sentry-element="MenuItem" data-sentry-source-file="ImageFilterRow.tsx">
          <Typography variant="body1" data-sentry-element="Typography" data-sentry-source-file="ImageFilterRow.tsx">AVIF</Typography>
        </MenuItem>
      </Menu>
    </>;
};